import { Navigate, Outlet } from 'react-router-dom'

import { useAuth } from '../../../contexts/AuthContext'
import { isTokenExpired } from '../../../utils/jwtUtils'

const AuthGuard = () => {
  const { authInfo, isAuthenticated } = useAuth()
  const accessToken = authInfo?.accessToken

  const hasValidAuthentication =
    isAuthenticated && accessToken && !isTokenExpired(accessToken)

  if (!hasValidAuthentication) {
    return <Navigate to="/login" replace />
  }

  return <Outlet />
}

export default AuthGuard
